__turbopack_context__.v({
  "error": "items-form-block1440px-module-scss-module__QaLUMW__error",
  "errorText": "items-form-block1440px-module-scss-module__QaLUMW__errorText",
  "form": "items-form-block1440px-module-scss-module__QaLUMW__form",
  "formblock": "items-form-block1440px-module-scss-module__QaLUMW__formblock",
  "icon": "items-form-block1440px-module-scss-module__QaLUMW__icon",
  "icon5": "items-form-block1440px-module-scss-module__QaLUMW__icon5",
  "interestedInSponsorship": "items-form-block1440px-module-scss-module__QaLUMW__interestedInSponsorship",
  "item1": "items-form-block1440px-module-scss-module__QaLUMW__item1",
  "item11": "items-form-block1440px-module-scss-module__QaLUMW__item11",
  "item2": "items-form-block1440px-module-scss-module__QaLUMW__item2",
  "items": "items-form-block1440px-module-scss-module__QaLUMW__items",
  "label": "items-form-block1440px-module-scss-module__QaLUMW__label",
  "leftcol": "items-form-block1440px-module-scss-module__QaLUMW__leftcol",
  "lookingForA": "items-form-block1440px-module-scss-module__QaLUMW__lookingForA",
  "lookingformblock1440px": "items-form-block1440px-module-scss-module__QaLUMW__lookingformblock1440px",
  "raceTeamImage": "items-form-block1440px-module-scss-module__QaLUMW__raceTeamImage",
  "rightcol": "items-form-block1440px-module-scss-module__QaLUMW__rightcol",
  "row": "items-form-block1440px-module-scss-module__QaLUMW__row",
  "submitButton": "items-form-block1440px-module-scss-module__QaLUMW__submitButton",
  "tellUsWhat": "items-form-block1440px-module-scss-module__QaLUMW__tellUsWhat",
  "tellUsWhatContainer": "items-form-block1440px-module-scss-module__QaLUMW__tellUsWhatContainer",
  "text": "items-form-block1440px-module-scss-module__QaLUMW__text",
  "text1": "items-form-block1440px-module-scss-module__QaLUMW__text1",
  "text6": "items-form-block1440px-module-scss-module__QaLUMW__text6",
  "textField": "items-form-block1440px-module-scss-module__QaLUMW__textField",
  "wrapper": "items-form-block1440px-module-scss-module__QaLUMW__wrapper",
});
